import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';
import { setIconColor } from 'modules/utils/cssUtils';
import { Flex } from '../flex';
import { NavigationAndActionOpenedFolder } from '../icons';
import { theme } from '../theme';
import { HeadlineTitle } from '../typography';

export const StyledContainer = styled(Flex)`
  justify-content: center;
  align-items: center;
  padding-top: 4.516rem;
  padding-bottom: 3.75rem;
  border: 3px dashed ${({theme}) => theme.colors.primaryK3};

  ${mediaQuery('md')} {
    padding-top: 5.891rem;
    padding-bottom: 5rem;
  }
`;

export const StyledEmptyIcon = styled(NavigationAndActionOpenedFolder)`
  width: 6.25rem;
  height: 6.25rem;

  ${({theme}) => setIconColor(theme.colors.primaryK3)};
`;

export const StyledDescription = styled(HeadlineTitle)`
  margin-top: 2.25rem;
  color: ${({theme}) => theme.colors.primaryK3};
  text-align: center;
`;
